import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GuineaBissauFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14792'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14792)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H0V14Z'
					fill='#1AB558'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 6.53333H20V0H0V6.53333Z'
					fill='#FFD952'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H7.61905V0H0V14Z'
					fill='#E72B42'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.80869 7.89481L2.4092 8.88767L2.94026 7.27648L1.54427 6.27892L3.27197 6.27601L3.80869 4.66663L4.3454 6.27601L6.07311 6.27892L4.67711 7.27648L5.20818 8.88767L3.80869 7.89481Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default GuineaBissauFlagIcon;
